// src/components/Dashboard/MainButton.js

import React from "react";
import { Button } from "@mui/material";
import PropTypes from 'prop-types';

const MainButton = ({ title, icon, onClick, disabled }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={icon}
      onClick={onClick}
      disabled={disabled}
      fullWidth
      sx={{ marginTop: 3 }}
    >
      {title}
    </Button>
  );
};

MainButton.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default MainButton;
